// extracted by mini-css-extract-plugin
export default {"base":"excursion-property-module--base--z6YMZ","icon":"excursion-property-module--icon--s2aB-"};